module.exports = __webpack_public_path__ + "img/logo-kks.c52ef648.png";